import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // On desktop the dashboard scrolls inside the SimpleBar wrapper (see Scrollbar in routes), not the window
    document.querySelector('main')?.closest('.simplebar-content-wrapper')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
